import { FC } from "react";

import "../../styles/Footer/Footer.css"

import Instagram from "../../assets/icons/instagram.png"
import Phone from "../../assets/icons/phone.png"
import Mail from "../../assets/icons/mail.png"
import FooterLogo from "../../assets/logos/wooblazz.png"
import KomdigiLogo from "../../assets/icons/komdigi.png"

const Footer: FC = () => {    
    const WA_NUMBER = "6282330779799";
    const WA_TEXT = "Halo saya tertarik dengan produk Wooblazz. Apa boleh didemokan dan diinfokan lebih lanjut? _[Compro Wooblazz > Footer]_";
    const encodedMessage = encodeURIComponent(WA_TEXT);
    const WA_LINK = `https://api.whatsapp.com/send?phone=${WA_NUMBER}&text=${encodedMessage}`;

    return (
        <footer className="sora text-start">
            <div className="bg-footer p-4">
                <div className="container-fluid mx-auto" style={{ maxWidth: '1200px' }}>
                    <div className="row">
                        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-start">
                            <div>
                                <img src={FooterLogo} alt="Footer Logo" className="img-fluid logo" style={{ maxHeight: '72px' }} />
                                <p className="text-sm mt-2">
                                    PT. Tunas Kreasi Digital
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-start align-items-md-end">
                            <div className="mt-2 mt-md-0">
                                <img src={KomdigiLogo} alt="Komdigi Logo" className="img-fluid me-4 me-md-5 logo" style={{ maxHeight: '48px' }} />
                                <a href="https://instagram.com/wooblazz" className="text-decoration-none" target="_blank" rel="noreferrer">
                                    <img src={Instagram} alt="Instagram" width={24} height={24} />
                                    <span className="ms-3 text-sm">
                                        wooblazz
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div className="col-12">
                            <hr className="my-4" style={{ color: '#D0D1D2' }} />
                        </div>
                        <div className="col-12 col-md-4 d-flex flex-column justify-content-start align-items-start">
                            <div className="mb-3 mb-md-0">
                                <h6 className="fw-semibold">Tangerang</h6>
                                <p className="text-sm">
                                    Ruko Arcadia Grande D-9 Gading Serpong, Tangerang
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 d-flex flex-column justify-content-start align-items-start">
                            <div className="mb-3 mb-md-0">
                                <h6 className="fw-semibold">Surabaya</h6>
                                <p className="text-sm">
                                    Voza Office Tower 16th Floor Jl. HR Muhammad 31A, Surabaya
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 d-flex flex-column justify-content-start align-items-start">
                            <div className="">
                                <h6 className="fw-semibold">Hongkong</h6>
                                <p className="text-sm">
                                    Unit 1603, 16/F, The L. Plaza 367–375 Queenʼs Road Central Sheung Wan, Hong Kong
                                </p>
                            </div>
                        </div>
                        <div className="col-12">
                            <hr className="my-4" style={{ color: '#D0D1D2' }} />
                        </div>
                        <div className="col-12 d-flex justify-content-evenly align-items-center flex-wrap">
                            <h6 className="fw-bold">Customer Care</h6>
                            <a href="mailto:partnership@looyal.id" className="text-decoration-none mb-2" target="_blank" rel="noreferrer">
                                <img src={Mail} alt="Instagram" width={24} height={24} />
                                <span className="ms-3 text-sm">
                                    partnership@looyal.id
                                </span>
                            </a>
                            <a href={WA_LINK} className="text-decoration-none" target="_blank" rel="noreferrer">
                                <img src={Phone} alt="Instagram" width={24} height={24} />
                                <span className="ms-3 text-sm">
                                    0823-3077-9799
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-footer-2 text-white py-2">
                <div className="d-flex justify-content-center">
                    <p className="p-copyright mb-0">Copyright ©{new Date().getFullYear()} All rights reserved | Wooblazz</p>
                </div>
            </div>
        </footer>

    )
}

export { Footer }